import { formatValue } from "../../PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { withProcessingLogic } from "../../../utils/utils.domain";
import { produce } from "../../../../libs/immer";
import { EModalStep } from "../../PaymentContainer/components/PaymentSelection/components/ModalLayout/EModalStep";
export var getMapStateToHeaderButtonsProps = function getMapStateToHeaderButtonsProps(_ref) {
  var login = _ref.login,
    getUserAccountInfo = _ref.getUserAccountInfo,
    getContent = _ref.getContent,
    Component = _ref.Component;
  return function (state, setState) {
    var _getUserAccountInfo = getUserAccountInfo(),
      accountNumber = _getUserAccountInfo.accountNumber;
    var content = getContent();
    var text = accountNumber ? formatValue(accountNumber !== null && accountNumber !== void 0 ? accountNumber : '') : content.header.login;
    return {
      closeButtonProps: {
        children: '',
        disabled: false,
        Component: Component,
        onClick: function onClick() {
          return setState(produce(function (draft) {
            if (draft.mobileStep === EModalStep.PaymentType) {
              draft.mobileStep = EModalStep.Input;
              return;
            }
            draft.isOpen = false;
          }));
        }
      },
      loginButtonProps: {
        children: text,
        disabled: false,
        onClick: function onClick() {
          withProcessingLogic(setState)(login()).catch(console.error);
        },
        shouldShowAccountNumber: !!text
      },
      logoProps: {}
    };
  };
};